import { Badge } from '@coreai/fluentui-react';
import { ArrowRedoRegular } from '@fluentui/react-icons';

/** Non-interactive marker for runs created by resubmitting another run. */
export const ResubmissionBadge = () => (
  <Badge
    appearance="tint"
    color="warning"
    size="small"
    shape="rounded"
    icon={<ArrowRedoRegular />}
    data-testid="run-resubmission-badge"
  >
    Resubmission
  </Badge>
);
